import { useCustomSWR } from 'utils/hooks/fetchers'

// search bar title 不需重複抓，故增加 revalidate 設定
export const useHomePageSearchBarTitle = (props) => {
  const { data, ...rest } = useCustomSWR(
    `/systemSettings/specificKey?key=homePageSearchBarTitle`,
    {
      revalidateOnFocus: false, // 當頁面重新聚焦時不重新驗證
      revalidateOnReconnect: false, // 當網路連線恢復時不重新驗證
    }
  )
  return {
    data: data?.[0]?.value,
    ...rest,
  }
}
